// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { QuoteValid } from '../Quotes/QuoteValid';
import { OperationType } from './OperationType';
import { OrderType } from './OrderType';
import { SlTpUtils } from './SlTpUtils';
export class OrderEditBaseUtils {
    static GetPriceByName(caller, paramName) {
        const params = caller.get('orderEditParameterArray');
        if (!isValidArray(params))
            return null;
        for (let i = 0; i < params.length; i++) {
            const param = params[i];
            if (!isNullOrUndefined(param) && param.name === paramName) {
                return param.value;
            }
        }
        return null;
    }
    static GetLimitPrice(caller) {
        const orderType = caller.get('orderType');
        const isStop = !isNullOrUndefined(orderType) && orderType.id() === OrderType.Stop;
        const isTrStop = !isNullOrUndefined(orderType) && orderType.id() === OrderType.TrailingStop;
        if (isStop) {
            return this.GetStopPrice(caller);
        }
        if (isTrStop) {
            return this.GetTrailingStopPrice(caller);
        }
        return this.GetPriceByName(caller, this.LIMIT_PRICE_PARAM);
    }
    static GetStopPrice(caller) {
        return this.GetPriceByName(caller, this.STOP_PRICE_PARAM);
    }
    static GetTrailingStopVisualOffset(caller) {
        return this.GetPriceByName(caller, this.TRAILING_STOP_PARAM);
    }
    static GetTrailingStopPrice(caller) {
        const visualOffset = this.GetTrailingStopVisualOffset(caller);
        const ins = caller.get('instrument');
        const isBuy = caller.get('operation') === OperationType.Buy;
        const lastQuote = !isNullOrUndefined(ins) ? ins.GetLastQuote(QuoteValid.Last) : null;
        if (isNullOrUndefined(lastQuote)) {
            return visualOffset;
        }
        const price = isBuy ? lastQuote.Ask : lastQuote.Bid;
        const sign = isBuy ? 1 : -1;
        const offsetType = SlTpUtils.getDefaultVisualOffsetTypeExcludePercent(ins);
        const realOffset = SlTpUtils.toRealValue(visualOffset, ins, offsetType);
        return ins.calculatePrice(price, realOffset * sign, true);
    }
}
OrderEditBaseUtils.LIMIT_PRICE_PARAM = 'limitPrice';
OrderEditBaseUtils.STOP_PRICE_PARAM = 'stopPrice';
OrderEditBaseUtils.SLTP_PARAM = 'sltp';
OrderEditBaseUtils.TRAILING_STOP_PARAM = 'trailingStop';
OrderEditBaseUtils.POSITION_SIZING_PARAM = 'positionSizing';
OrderEditBaseUtils.REAL_TRSTOP_PRICE = 'RealTrStopPrice';
OrderEditBaseUtils.PRODUCT_TYPE_AND_MQ = 'ModifyQuantity'; // Target product type + Modify quantity
OrderEditBaseUtils.ATTENTION_MSG = 'attention';
OrderEditBaseUtils.LIMIT_PRICE_PARAM_CHANGE_FROM_LAST_PRICE = 'limitPriceChangeFromLast'; // https://tp.traderevolution.com/entity/108864
OrderEditBaseUtils.SLTP_TRIGGER = 'sltpTrigger'; // for position with sltp & triggers modify #109386
OrderEditBaseUtils.EST_AVAILABLE_CASH = 'estAvailableCash';
OrderEditBaseUtils.OFFMARKET_ENABLED = 'offmarketEnabled';
OrderEditBaseUtils.BOUNDTO = 'boundTo';
